<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <h1 class="mb-0">{{ page_title }}</h1>
    <div class="page-title-actions">
      <a mat-flat-button color="accent" routerLink="/employees/rrhh/surveys/create">
        <mat-icon>add</mat-icon>
        Crear
      </a>
    </div>
  </div>

  <div class="survey-kpi-grid">
    <app-survey-kpi-card label="Encuestas activas" [value]="active_surveys_count" icon="fact_check"></app-survey-kpi-card>

    <app-survey-kpi-card
      label="Última remesa enviada"
      [value]="latest_wave_value"
      [hint]="latest_wave_hint"
      [progress]="latest_wave_progress"
      icon="send"
    ></app-survey-kpi-card>

    <app-survey-kpi-card label="Siguiente remesa" [value]="next_wave_value" [hint]="next_wave_hint" icon="event"></app-survey-kpi-card>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="status">
          @for (status_option of status_filter_options; track status_option.value) {
            <mat-option [value]="status_option.value">{{ status_option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element; dataSource: data_source">{{ element.title }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element; dataSource: data_source">
            <span [class]="'status-badge status-' + element.status">{{ element.status_label }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="frequency">
          <th mat-header-cell *matHeaderCellDef>Frecuencia</th>
          <td mat-cell *matCellDef="let element; dataSource: data_source">
            @if (element.current_survey_variable_condition?.frequency; as frequency) {
              <span [class]="'frequency-badge frequency-' + frequency">{{ element.frequency_label }}</span>
            } @else {
              <span>—</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="latest_wave_progress">
          <th mat-header-cell *matHeaderCellDef>Progreso última remesa</th>
          <td mat-cell *matCellDef="let element; dataSource: data_source">
            @if (element.latest_wave_progress; as progress) {
              <button
                type="button"
                class="wave-progress-trigger"
                matTooltip="Ver detalle de los usuarios"
                (click)="openProgressDetail(progress)"
              >
                <div class="wave-progress">
                  <mat-progress-bar mode="determinate" [value]="element.latest_wave_progress_percent ?? 0"></mat-progress-bar>
                  <span class="wave-progress-label">{{ element.latest_wave_progress_label }}</span>
                </div>
              </button>
            } @else {
              <span>—</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; dataSource: data_source" class="actions-cell">
            <div class="table-actions">
              <a mat-icon-button matTooltip="Editar" [routerLink]="['/employees', 'rrhh', 'surveys', element.id, 'edit']">
                <mat-icon>edit</mat-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
</div>
